<template>
    <div style="width: 100%" class="px-7">
        <v-row no-gutters style="flex-wrap: nowrap">
            <v-col class="display-1 flex-grow-1 flex-shrink-0 text-h4"> Public API </v-col>
            <v-col cols="2" class="flex-grow-0 flex-shrink-0">
                <v-btn-primary block @click="openAddApiUserDialog()" size="large"
                    >Ajouter un utilisateur</v-btn-primary
                >
            </v-col>
            <v-col class="flex-grow-0 flex-shrink-1 px-3">
                <v-btn-icon icon="$fa-book" @click="hrefDocumentation()" />
            </v-col>
        </v-row>
        <v-row no-gutters class="mt-3">
            <v-col cols="6">
                <v-card class="rounded-xl fill-height" elevation="0">
                    <v-card-title>
                        <v-row no-gutters>
                            <v-col cols="6"> Utilisateurs </v-col>
                            <v-col cols="6" class="d-flex align-center">
                                <v-text-field-filled
                                    v-model="searchPublicApiUser"
                                    label="Rechercher"
                                    single-line
                                    hide-details
                                    outlined
                                    prepend-inner-icon="$search"
                                    class="my-n3 mr-n3"
                                    density="compact"
                                    clearable
                                    append-inner-icon="$search"
                                    @click:clear="searchPublicApiUser = ''"
                                />
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text style="overflow-y: auto; height: calc(100vh - 224px)">
                        <v-list nav density="compact">
                            <template v-if="!publicApiUsersFiltred.length">
                                Aucun resultat trouvé pour la recherche
                            </template>
                            <template v-for="user of publicApiUsersFiltred" :key="user.id">
                                <v-list-item class="oss-list-item" two-line>
                                    <!-- <v-list-item-icon class="d-flex align-center">
                                        <v-icon>$fa-user</v-icon>
                                    </v-list-item-icon> -->
                                    <v-list-item-title>
                                        {{ user.firstname }} {{ user.lastname }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ user.company.shortName || user.company.name }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        {{ printProfileName(getProfileName(user.profile)) }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle v-if="user.externalId">
                                        {{ "Identifiant externe : " + user.externalId }}
                                    </v-list-item-subtitle>
                                    <template v-slot:append>
                                        <v-btn-icon
                                            icon="$oss-edit"
                                            @click="openEditApiUserDialog(user)"
                                        />
                                    </template>
                                </v-list-item>
                                <v-divider />
                            </template>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <oss-dialog
            v-if="addApiUserDialog"
            v-model="addApiUserDialog"
            title="Ajouter un utilisateur"
            :valid-title="validTextAPIUserCreation"
            :valid-disabled="!isValidAPIUserCreation"
            @valid="valid()"
            @close="addApiUserDialog = false"
            width="60vw"
        >
            <v-row no-gutters>
                <v-col cols="12">
                    <v-window v-model="step">
                        <v-window-item value="createUser">
                            <v-row no-gutters class="py-1">
                                <v-col cols="6" class="px-2">
                                    <v-text-field-filled
                                        v-model="user.firstname"
                                        label="Prénom*"
                                        required
                                        outlined
                                        dense
                                    />
                                </v-col>
                                <v-col cols="6" class="px-2">
                                    <v-text-field-filled
                                        v-model="user.lastname"
                                        label="Nom*"
                                        required
                                        outlined
                                        density="compact"
                                    />
                                </v-col>
                                <v-col cols="6" class="px-2">
                                    <v-text-field-filled
                                        label="Société*"
                                        required
                                        outlined
                                        readonly
                                        @click="goToSelectCompany()"
                                        :model-value="user.company.name"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col cols="6" class="px-2">
                                    <v-select-filled
                                        v-model="user.profile.id"
                                        :items="availableProfiles"
                                        :item-title="getProfileName"
                                        item-value="id"
                                        label="Profil*"
                                        outlined
                                        dense
                                    />
                                </v-col>
                                <v-col cols="6" class="px-2">
                                    <v-text-field-filled
                                        v-model="user.externalId"
                                        label="Identifiant externe"
                                        outlined
                                        dense
                                    />
                                </v-col>
                            </v-row>
                        </v-window-item>
                        <v-window-item value="selectCompany">
                            <CompaniesTable
                                :showGenericCompany="false"
                                :showCustomerCompanies="false"
                                :showSupplierCompanies="false"
                                :showBobbeeCompanies="true"
                                :showExistingCompanies="false"
                                :parentCompanyId="companyId"
                                @select-company="companySelected"
                            />
                        </v-window-item>
                        <v-window-item value="login">
                            <v-row no-gutters class="d-flex justify-center pt-2">
                                <v-col cols="6">
                                    <v-text-field-filled
                                        outlined
                                        :value="login.publicKey"
                                        dense
                                        readonly
                                        label="Login"
                                    >
                                        <template v-slot:append>
                                            <v-btn-icon
                                                icon="$fa-copy"
                                                color="primary"
                                                @click="copy(login.publicKey)"
                                                size="small"
                                            />
                                        </template>
                                    </v-text-field-filled>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="d-flex justify-center">
                                <v-col cols="6">
                                    <v-text-field-filled
                                        outlined
                                        :value="login.privateKey"
                                        dense
                                        readonly
                                        :type="showPassword ? 'text' : 'password'"
                                        label="Mot de passe"
                                    >
                                        <template v-slot:append>
                                            <v-btn
                                                color="primary"
                                                @click="showPassword = !showPassword"
                                                size="small"
                                            >
                                                <v-icon color="primary" size="small">{{
                                                    showPassword ? "$fa-eye-slash" : "$fa-eye"
                                                }}</v-icon>
                                            </v-btn>
                                            <v-btn-icon
                                                icon="$fa-copy"
                                                color="primary"
                                                @click="copy(login.privateKey)"
                                                size="small"
                                            />
                                        </template>
                                    </v-text-field-filled>
                                </v-col>
                            </v-row>
                        </v-window-item>
                    </v-window>
                </v-col>
            </v-row>
        </oss-dialog>
        <v-snackbar v-model="snackbarTextCopied" :timeout="2000">
            Texte Copié !
            <template v-slot:actions>
                <v-btn @click="snackbarTextCopied = false" variant="text"> Close </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import GENERATE_API_USER from "../../graphql/controlCenter/GenerateApiUser.gql";
import PUBLIC_API_USER from "../../graphql/controlCenter/PublicApiUser.gql";
import REFERENCE_PROFILES from "@/graphql/profiles/ReferenceProfiles.gql";

import CompaniesTable from "../admin/CompaniesTable.vue";
import { getProfileName } from "../../services/profile";

import { orderBy } from "lodash";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        CompaniesTable,
    },
})
export class ControlCenterAPI extends Vue {
    addApiUserDialog = false;
    snackbarTextCopied = false;
    showPassword = false;

    searchPublicApiUser = "";

    step = "createUser";

    user = {
        id: undefined,
        firstname: "",
        lastname: "",
        company: {
            name: "",
            id: undefined,
        },
        profile: {
            id: undefined,
            name: "",
        },
        externalId: null,
    };

    login = {
        publicKey: "",
        privateKey: "",
    };

    get isValidAPIUserCreation() {
        switch (this.step) {
            case "createUser":
                return (
                    this.user.firstname &&
                    this.user.lastname &&
                    this.user.company.id &&
                    this.user.profile.id
                );
            case "selectCompany":
                return this.user.company.id;
            case "login":
                return true;
        }
    }

    get companyId() {
        return this.currentUser?.company?.id || undefined;
    }

    get publicApiUsersFiltred() {
        if (!this.searchPublicApiUser) {
            return this.publicApiUsers;
        }
        return this.publicApiUsers.filter((user) => {
            return (
                user.firstname.toLowerCase().includes(this.searchPublicApiUser.toLowerCase()) ||
                user.lastname.toLowerCase().includes(this.searchPublicApiUser.toLowerCase()) ||
                user.company.name.toLowerCase().includes(this.searchPublicApiUser.toLowerCase()) ||
                user.company?.shortname
                    ?.toLowerCase()
                    .includes(this.searchPublicApiUser.toLowerCase()) ||
                user.profile.name.toLowerCase().includes(this.searchPublicApiUser.toLowerCase()) ||
                user.externalId.toLowerCase().includes(this.searchPublicApiUser.toLowerCase()) ||
                user.login === this.searchPublicApiUser
            );
        });
    }

    get validTextAPIUserCreation() {
        switch (this.step) {
            case "createUser":
                return this.user?.id ? "Modifier " : "Ajouter";
            case "selectCompany":
                return "Sélectionner une société";
            case "login":
                return "Terminer";
        }
    }

    get currentUser() {
        return this.$store.state.user;
    }

    hrefDocumentation() {
        window.open("https://documenter.getpostman.com/view/20732310/UyrHfDR7", "_blank");
    }

    openAddApiUserDialog() {
        this.step = "createUser";
        if (this.user.id) {
            this.user = {
                id: null,
                firstname: "",
                lastname: "",
                company: {
                    name: "",
                    id: undefined,
                },
                profile: {
                    id: undefined,
                    name: "",
                },
                externalId: null,
            };
            this.login = {
                publicKey: "",
                privateKey: "",
            };
        }
        this.addApiUserDialog = true;
    }

    companySelected(company) {
        this.user.company = company;
        this.step = "createUser";
    }

    goToSelectCompany() {
        this.step = "selectCompany";
    }

    getProfileName(profile) {
        if (profile && profile.id) {
            return getProfileName(this, profile);
        }
        return "Profil non défini";
    }

    printProfileName(profileName) {
        if (profileName && profileName !== "Profil non défini") {
            if (profileName.startsWith("profiles.name.")) {
                return profileName.replace("profiles.name.", "");
            }
            return profileName;
        }
    }

    copy(textToSet) {
        const textArea = document.createElement("textarea");
        textArea.value = textToSet;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        this.snackbarTextCopied = true;
    }

    @Apollo({
        query: PUBLIC_API_USER,
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.publicApiUser && data.publicApiUser.length) {
                    this.publicApiUsers = orderBy(
                        JSON.parse(JSON.stringify(data.publicApiUser)),
                        "company.name",
                    );

                    if (this.publicApiUsers.length) {
                        this.publicApiUsers.forEach((user) => {
                            if (user.profile) {
                                user.profile = {
                                    id: user.profile.id,
                                    name: getProfileName(this, user.profile),
                                };
                            } else {
                                user.profile = {
                                    id: undefined,
                                    name: "",
                                };
                            }
                        });
                    }
                }
            }
        },
    })
    publicApiUsers: any = [];

    @Apollo({
        query: REFERENCE_PROFILES,
        variables() {
            return {
                companyId: this.currentUser.company.id,
            };
        },
        skip() {
            return !this.currentUser?.id || !this.currentUser?.company?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.profiles) {
                    data.profiles.sort((a, b) => {
                        if (this.$t("profiles.name." + a.name) < this.$t("profiles.name." + b.name))
                            return -1;
                        if (this.$t("profiles.name." + a.name) > this.$t("profiles.name." + b.name))
                            return 1;
                        return 0;
                    });

                    this.availableProfiles = data.profiles;
                }
            }
        },
    })
    availableProfiles: any = [];

    async valid() {
        switch (this.step) {
            case "createUser":
                // this.addApiUserDialog = false
                return await this.generateApiUser();
            case "login":
                this.addApiUserDialog = false;
                this.user = {
                    id: null,
                    firstname: "",
                    lastname: "",
                    company: {
                        name: "",
                        id: undefined,
                    },
                    profile: {
                        id: undefined,
                        name: "",
                    },
                    externalId: null,
                };
                this.login = {
                    publicKey: "",
                    privateKey: "",
                };
                this.step = "createUser";
                return;
        }
    }

    async generateApiUser() {
        let user = {
            firstname: this.user.firstname,
            lastname: this.user.lastname,
            companyId: this.user.company.id,
            userId: this.user.id || undefined,
            profileId: this.user.profile.id || undefined,
            externalId: this.user.externalId || null,
        };

        let result = await this.$apollo.mutate({
            mutation: GENERATE_API_USER,
            variables: {
                user,
            },
        });

        this.login = result.data.generateAPIUser;
        this.step = "login";
        this.refresh();
    }

    openEditApiUserDialog(user) {
        this.user = user;
        this.step = "createUser";
        this.addApiUserDialog = true;
    }

    refresh() {
        this.$apollo.queries.publicApiUser.refetch();
        this.$apollo.queries.publicApiUser.refetch();
    }
}

export default toNative(ControlCenterAPI);
</script>
